/* global ha */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SearchBox from '@homeaway/react-searchbox-lite';

import {getValue, TESTS} from '../../../../shared/utils/abacus';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import SameDayAvailability from './sameDayAvailability/SameDayAvailability';

import {setSearchData} from '../../../actions/search';
import {getSearchValues} from '../../../utils/search';
import {redirect} from '../../../actions/search';

import {getActionLocation} from '../../../utils/edap';

export function mapStateToProps({abacus, config, destination, i18n, modules, search}) {
    const propertyType = destination.propertyType;
    const dayTemplateComponent = getValue(abacus, TESTS.HA_TRAVELER_SAME_DAY_BOOKINGS) === 1 ? {dayTemplateComponent: SameDayAvailability} : {};
    return {
        abacus,
        dayTemplateComponent,
        prefix: config.url.prefix,
        details: destination.details,
        fabId: !isNaN(parseInt(propertyType, 10)) ? propertyType : null,
        lbsId: destination && destination.details ? destination.details.lbsId : null,
        searchValues: search,
        locale: i18n.locale,
        site: config.site,
        isMobile: config.isMobile,
        labels: modules.searchBoxLite.labels,
        resetForm: modules.searchBoxLite.resetForm,
        edapPageType: getActionLocation(config.template)
    };
}

export function mapDispatchToprops(dispatch) {
    return {
        setSearchData,
        dispatch
    };
}

export class SearchBoxLiteComponent extends Component {
    static propTypes = {
        details: PropTypes.shape({
            fullName: PropTypes.string
        }),
        dayTemplateComponent: PropTypes.func,
        geoType: PropTypes.string,
        isMobile: PropTypes.bool,
        lbsId: PropTypes.string,
        prefix: PropTypes.string,
        resetForm: PropTypes.bool,
        searchValues: PropTypes.shape({
            adults: PropTypes.number,
            arrivalDate: PropTypes.string,
            children: PropTypes.number,
            departureDate: PropTypes.string,
            petIncluded: PropTypes.bool
        }),
        showConsolidate: PropTypes.bool
    };

    static defaultProps = {
        isMobile: false,
        resetForm: false
    };

    componentDidMount() {
        ha.userTiming.mark('primary.action.rendered');
        ha.userTiming.mark('datepicker.active');

        const cookies = document.cookie;
        const {searchValues, abacus} = this.props;
        const searchCookies = getSearchValues(cookies, abacus);

        if (!searchCookies || !searchValues) {
            return;
        }

        const differentSearchData =
            searchValues.arrivalDate !== searchCookies.arrivalDate ||
            searchValues.departureDate !== searchCookies.departureDate ||
            searchValues.adults !== searchCookies.adults ||
            searchValues.children !== searchCookies.children ||
            searchValues.petIncluded !== searchCookies.petIncluded;

        if (differentSearchData) {
            this.props.dispatch(setSearchData(searchCookies));
        }
    }

    onSubmit = ({searchPath}) => {
        const redirectPath = `${this.props.site.basePath || ''}${searchPath}`;
        this.props.dispatch(redirect(redirectPath));
    };

    onOpen = () => {
        AbacusClientUtils.logExperiment(TESTS.HA_TRAVELER_SAME_DAY_BOOKINGS);
    };

    render = () => {
        const {
            adults,
            children,
            petIncluded,
            departureDate,
            arrivalDate
        } = this.props.searchValues;

        const {
            fabId,
            isMobile,
            labels,
            lbsId,
            locale,
            prefix,
            resetForm,
            site,
            edapPageType,
            dayTemplateComponent
        } = this.props;

        const guests = {
            adultsCount: adults,
            childrenCount: children,
            petIncluded
        };

        const destination = resetForm ? '' : this.props.details.fullName;
        return (
            <React.Fragment>
                <SearchBox
                    checkIn={arrivalDate}
                    checkOut={departureDate}
                    onSubmit={this.onSubmit}
                    onOpen={this.onOpen}
                    edapDatePickerLabel={'0'}
                    labels={labels}
                    domain={site.domain}
                    edapActionlocationSearchQuerySubmitted={edapPageType}
                    typeaheadProps={{
                        site: site.name,
                        baseUrl: `https://${site.domain}`,
                        appPrefix: prefix
                    }}
                    {...{lbsId, destination, guests, locale, isMobile, fabId}}
                    {...dayTemplateComponent}
                />
            </React.Fragment>
        );
    };
}

export const SearchBoxLite = connect(mapStateToProps, mapDispatchToprops)(SearchBoxLiteComponent);

SearchBoxLite.displayName = 'SearchBoxLite';

export default SearchBoxLite;
